import { Reveal } from "./motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../data";

export const Testimonials = () => (
  <section id="avis" data-testid="testimonials" className="relative py-28 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.3em] text-champagne font-semibold mb-5">Ils nous font confiance</p>
        <h2 className="font-serif font-light text-4xl sm:text-5xl text-[#F7F5F0] leading-tight mb-16 max-w-2xl">
          Des trajets, <span className="italic text-champagne">des sourires</span>
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <div className="h-full border border-white/10 rounded-2xl p-8 bg-[#0C1322]/40 flex flex-col">
              <Quote className="text-champagne mb-6" size={28} />
              <p className="text-[#F7F5F0] leading-relaxed mb-8 flex-1 text-[15px]">"{t.text}"</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-[#F7F5F0] font-medium">{t.name}</p>
                <p className="text-[#94A3B8] text-sm">{t.role}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
